import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';

import {
  cadastroCondutorInRequest,
  deleteCadastroCondutor,
  findCadastroCondutor,
  recordFiltering,
} from '~/store/modules/cadastrocondutor/actions';

import CadastroCondutorForm from './form';

function CadastroCondutor() {
  const cadastrocondutor = useSelector((state) => state.cadastrocondutor);

  const listaCondStatus = useMemo(
    () => [
      { label: 'A', value: 'Ativo' },
      { label: 'D', value: 'Impedimento DETRAN' },
      { label: 'R', value: 'Impedimento RH' },
      { label: 'S', value: 'Sem senha cadastrada' },
      { label: 'I', value: 'Inativo' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'cond_cpf',
        label: 'CPF:',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'cond_nome',
        label: 'Nome',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_nome',
        label: 'Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'cond_status_str',
        label: 'Status',
        align: 'center',
        converter: listaCondStatus,
        filter: {
          type: 'select',
          options: listaCondStatus,
        },
      },
    ],
    []
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="cond_cpf ASC"
        fixed
        create={false}
        delete={false}
        update={false}
        header={header}
        redux={cadastrocondutor}
        //custom={filter}
        //actions={buttons}
        keys={['cond_cpf']}
        detach="cond_cpf"
        read={recordFiltering}
        find={findCadastroCondutor}
        //remove={deleteCadastroMarca}
        form={CadastroCondutorForm}
        view="VW_CONDUTOR"
        reportTitle="Cadastro de Condutor"
      />

      {/* <Tabela
        read={cadastroCondutorInRequest}
        remove={deleteCadastroCondutor}
        state={cadastrocondutor}
        header={header}
        noCreate
        noEdition
        headerMobile="cond_cpf"
        unique={['cond_cpf']}
        form={CadastroCondutorForm}
        findItem={findCadastroCondutor}
        recordFilter={recordFiltering}       
      /> */}
    </>
  );
}

export default CadastroCondutor;
